export const refreshTokenCookieName: string = 'PassportRefreshToken';
export const accessTokenCookieName: string = 'PassportAccessToken';
export const accessTokenExpiresName: string = 'PassportExpiresIn';
